import React from 'react'
import { Helmet } from 'react-helmet'
import GNS3HomeLayout from 'src/custom/gns3/Home/Layout'
import MotherWebsiteHomeLayout from 'src/custom/mother-website/HomeLayout'
import { useOrganization } from 'src/graphql/hooks'
import HomeActions from 'src/legacy/5.6/Home/Actions'
import LegacyABEdLeadershipLayout from 'src/legacy/5.6/Home/ABEdLeadership'
import LegacyElacLayout from 'src/legacy/5.6/Home/ElacLayout'
import LegacyFuseLayout from 'src/legacy/5.6/Home/FuseLayout'
import LegacyLayout1 from 'src/legacy/5.6/Home/Layout1'
import LegacyLayout2 from 'src/legacy/5.6/Home/Layout2'
import LayoutDefault from '~/components/LayoutDefault'

const layouts = [
   null,
   LegacyLayout1,
   LegacyLayout2, // (ASLC and others)
   LegacyABEdLeadershipLayout,
   LegacyFuseLayout, // Fuse
   MotherWebsiteHomeLayout, // Mother.co home
   LegacyElacLayout,
   GNS3HomeLayout,
   LayoutDefault // Bleeding Edge
]

const HomeApp = () => {
   const { organization } = useOrganization()
   const { currentUserCanEdit, homeContainerLayoutKey, name } = organization

   const defaultLayout = layouts[1]
   const Layout = layouts[homeContainerLayoutKey] || defaultLayout

   return (
      <>
         <Helmet title={name} />
         <Layout />
         {currentUserCanEdit && <HomeActions />}
      </>
   )
}

export default HomeApp
